'use client';

import { useEffect, useState } from 'react';

// Compact audio waveform
export default function MiniWaveform({
  bars = 16,
  active = true
}: {
  bars?: number;
  active?: boolean;
}) {
  const [levels, setLevels] = useState<number[]>(() =>
    Array.from({ length: bars }, () => Math.random())
  );
  useEffect(() => {
    if (!active) return;
    const id = setInterval(() => {
      setLevels((prev) => prev.map(() => 0.2 + Math.random() * 0.8));
    }, 100);
    return () => clearInterval(id);
  }, [bars, active]);
  return (
    <div className="flex items-center justify-center gap-0.5 h-full">
      {levels.map((v, i) => (
        <div
          key={i}
          className="bg-videomule-green rounded-full transition-all duration-100"
          style={{ width: '2px', height: `${v * 100}%` }}
        />
      ))}
    </div>
  );
}
